'use client';

import { useEffect } from 'react';
import { installClientLogging } from '@/lib/client-log';

/**
 * Monta el reporte de fallos del navegador. Va en el layout para cubrir toda la
 * aplicación; no pinta nada y, si la recolección está apagada, se desmonta solo
 * en cuanto lo confirma el servidor.
 */
export default function ClientLogReporter() {
  useEffect(() => installClientLogging(), []);
  return null;
}
